// FAQs Accordion Js

const accordionTriggers = document.querySelectorAll('.accordion-trigger');

accordionTriggers.forEach(trigger => {
    trigger.addEventListener('click', () => {
        const faqItem = trigger.parentElement.parentElement;
        const answer = faqItem.querySelector('.faq-answer');

        faqItem.classList.toggle('open');

        if (faqItem.classList.contains('open')) {
            const otherFaqItems = document.querySelectorAll('.faq-item');
            otherFaqItems.forEach(item => {
                if (item !== faqItem && item.classList.contains('open')) {
                    item.classList.remove('open');
                }
            });
        }
    });
});

// Custom Collapsible Accordion Js

$(document).ready(function () {
    function closeOtherAccordions(clickedButton) {
      $(".custom-collapsible-accordion-button").each(function () {
        if ($(this)[0] !== clickedButton[0]) {
          $(this).removeClass("active");
          var content = $(this).next();
          content.removeClass("open");
          content.css("max-height", "0");
        }
      });
    }

    $(".custom-collapsible-accordion-button").click(function () {
      var clickedButton = $(this);

      closeOtherAccordions(clickedButton);

      clickedButton.toggleClass("active");
      var content = clickedButton.next();
      content.toggleClass("open");

      if (content.hasClass("open")) {
        content.css("max-height", content[0].scrollHeight + "px");
      } else {
        content.css("max-height", "0");
      }
    });
  });


// Reviews Slider

$(document).ready(function(){
  $('.reviews-slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1, 
    autoplay: false, 
    autoplaySpeed: 3000, 
    dots: true,
    arrows: false, 
    responsive: [
      {
        breakpoint: 1080, 
        settings: {
          slidesToShow: 2 
        }
      },
      {
        breakpoint: 768, 
        settings: {
          slidesToShow: 1 
        }
      }
    ]
  });
});


// Smooth scroll to the section 
document.addEventListener('DOMContentLoaded', function() {
  const links = document.querySelectorAll('a[href^="#"]');
  
  for (const link of links) {
    link.addEventListener('click', smoothScroll);
  }

  function smoothScroll(e) {
    e.preventDefault();
    const targetId = this.getAttribute('href').substring(1);
    const targetElement = document.getElementById(targetId);
    
    if (targetElement) {
      const offsetTop = targetElement.getBoundingClientRect().top;
      const scrollOptions = {
        behavior: 'smooth',
        block: 'start'
      };
      
      window.scrollTo({
        top: offsetTop + window.scrollY,
        ...scrollOptions
      });
    }
  }
});


$("#shopElement a").click(function(){
  
  $("#Details-menu-drawer-container").removeAttr('open');
  $("body").removeClass("overflow-hidden-tablet");
  $("#Details-menu-drawer-container summary").attr("aria-expanded", "false");
});




